import { RootState } from '../store';

export const selectSelectedImage = (state: RootState) => state.image.selectedImage;
export const selectTemporaryTexts = (state: RootState) => state.image.temperoryTexts;
export const selectSelectedText = (state: RootState) => state.image.selectedText;
export const selectCanvasGap = (state: RootState) => state.image.imageLayout?.gap_size;
export const selectUploadImages = (state: RootState) => state.image.uploadImages;
export const selectLoadingSave = (state: RootState) => state.image.loadingSave;
export const selectLoadingCancel = (state: RootState) => state.image.loadingCancel;
export const selectImageProject = (state: RootState) => state.image.imageProject;
export const selectImageLayout = (state: RootState) => state.image.imageLayout;
// export const selectTemporaryLayout = (state: RootState) => state.image.temporaryLayout;
export const selectLoadingCreateLayout = (state: RootState) => state.image.loadingCreateLayout;
export const selectDraggedImage = (state: RootState) => state.image.draggedImage;
export const selectLoading = (state: RootState) => state.image.loading;
export const selectSelectedSlotIndex = (state: RootState) => state.image.selectedSlotIndex;
export const selectLoadingDownload = (state: RootState) => state.image.loadingDownload;
export const selectHasChanged = (state: RootState) => state.image.hasChanged;
